import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { OpportunityService } from "../../../services/opportunity.service";
import {
  CdkCell,
  CdkCellDef,
  CdkColumnDef,
  CdkHeaderCell,
  CdkHeaderCellDef,
  CdkHeaderRow,
  CdkHeaderRowDef,
  CdkRow,
  CdkRowDef,
  CdkTable
} from "@angular/cdk/table";
import { DatePipe, NgClass, NgIf } from "@angular/common";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faCircle as faCircleRegular } from "@fortawesome/pro-regular-svg-icons/faCircle";
import { faCircleX } from "@fortawesome/pro-solid-svg-icons/faCircleX";
import { faCircle, faGear } from "@fortawesome/pro-solid-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { PurchasedReferralDatasource } from "../../../utility/purchased-referral-datasource";
import { AuthGuard } from "../../../auth/auth.guard";
import { UtilityService } from "../../../services/utility.service";
import { environment } from "../../../../environments/environment";
import { DetailsPanelComponent } from "../../details-panel/details-panel.component";
import { PublicClaimModalComponent } from "../../public-claim-modal/public-claim-modal.component";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { Subject } from "rxjs";
import { ClaimItReferral } from "../../../models/claim-it-referral.model";
import { Environment } from "../../../../environments/environment.model";
import { StateManagementService } from "../../../services/state-management.service";
import { CustomCdkTooltipDirective } from "../../../directives/custom-cdk-tool-tip.directive";

@Component({
  selector: "app-purchased-referrals",
  standalone: true,
  imports: [
    CdkCell,
    CdkTable,
    CdkColumnDef,
    CdkHeaderCell,
    CdkHeaderRow,
    CdkRow,
    FaIconComponent,
    CdkCellDef,
    CdkHeaderCellDef,
    NgIf,
    CdkHeaderRowDef,
    CdkRowDef,
    NgClass,
    DatePipe,
    DetailsPanelComponent,
    PublicClaimModalComponent,
    CustomCdkTooltipDirective
  ],
  templateUrl: "./purchased-referrals.component.html",
  styleUrl: "./purchased-referrals.component.scss"
})
export class PurchasedReferralsComponent implements OnInit, OnDestroy {
  @Input() loadGeoIpStateFilter: boolean = false;
  @Input() enableDetailsPanel: boolean = true;
  @Input() showDateFilter: boolean = true;
  @Input() showStateFilter: boolean = false;
  @Input() showHeader: boolean = true;
  @Input() showPrices: boolean = true;
  @Input() selectedStateCodeFilter: string | null = null;
  @Input() selectedDateFilter: string | null = "48hours";
  @Input() defaultDateOptionIndex: number = 1;
  @Input() selectedIndex: number | null = null;
  @Input() columnsToDisplay: string[] = [
    "lastModDate",
    "type",
    "name",
    "phone",
    "email",
    "city",
    "category",
    "businessLines"
  ];
  protected readonly faGear: IconDefinition = faGear;
  protected readonly environment: Environment = environment;
  protected readonly UtilityService: typeof UtilityService = UtilityService;
  protected selectedReferral: ClaimItReferral | null = null;
  protected dataSource: PurchasedReferralDatasource = new PurchasedReferralDatasource(
    this.opportunityService,
    "lastModDate",
    "desc",
    0,
    25,
    null,
    3000
  );
  protected icons: { [id: string]: IconDefinition } = {
    Assigned: faCircleCheck,
    Claimed: faCircleCheck,
    Available: faCircle,
    Settled: faCircleCheck,
    Incoming: faCircleRegular,
    Ineligible: faCircleX,
    Delivered: faCircleCheck,
    Undefined: faCircleX
  };
  protected isLoading: boolean = true;
  protected openModal$: Subject<void> = new Subject<void>();

  constructor(
    protected authGuard: AuthGuard,
    public stateManagementService: StateManagementService,
    private opportunityService: OpportunityService
  ) {}

  ngOnInit(): void {
    this.stateManagementService.setPageTitle("Acquired Referrals | Momentum Edge");
    this.stateManagementService.pageHeading.set("Acquired Referrals");
    this.authGuard.fetchUsername().subscribe((username: string | null): void => {
      this.dataSource = new PurchasedReferralDatasource(
        this.opportunityService,
        "lastModDate",
        "desc",
        0,
        25,
        username,
        3000
      );
    });
  }

  ngOnDestroy(): void {
    this.stateManagementService.resetHeadingAndTitle();
    this.dataSource?.disconnect();
  }

  finishedLoading(): void {
    setTimeout((): boolean => (this.isLoading = false));
  }

  setSelectedReferral(referral: any, index: number | null): void {
    if (!this.enableDetailsPanel) {
      return;
    }
    this.selectedReferral = referral;
    this.selectedIndex = index;
  }

  concatenateName(firstName: string, lastName: string): string {
    if (firstName != null && lastName != null) {
      return firstName + " " + lastName;
    } else if (firstName != null) {
      return firstName;
    } else {
      return lastName;
    }
  }
}
